import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Formik
import { useFormikContext } from 'formik';
// Elements
import Label from '../elements/Label';
import Error from '../elements/Error';
var inputTypes = {
  phone: 'tel'
};
var TextField = function TextField(_ref) {
  var _ref$formik = _ref.formik,
    formik = _ref$formik === void 0 ? {} : _ref$formik,
    _ref$hasError = _ref.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError,
    fieldId = _ref.fieldId,
    data = _ref.data;
  var _useFormikContext = useFormikContext(),
    handleChange = _useFormikContext.handleChange,
    handleBlur = _useFormikContext.handleBlur,
    values = _useFormikContext.values;
  var type = data.type.toLowerCase();
  // Conditional logic
  if (data.conditionalLogic) {
    // Whether or not to show the field
    if (data.conditionalLogic.actionType === 'SHOW') {
      var show = true;
      data.conditionalLogic.rules.forEach(function (rule) {
        if (rule.operator === 'IS') {
          if (values["input_".concat(rule.fieldId)] !== rule.value) {
            show = false;
          }
        }
        if (rule.operator === 'IS_NOT') {
          if (values["input_".concat(rule.fieldId)] === rule.value) {
            show = false;
          }
        }
      });
      if (!show) {
        return null;
      }
    }
  }
  return _jsxs("div", {
    className: "form-duuf-group form-duuf-group-".concat(type).concat(data.cssClass ? " ".concat(data.cssClass) : ''),
    children: [_jsx(Label, {
      fieldId: fieldId,
      data: data
    }), _jsx(Error, {
      fieldId: fieldId,
      data: data,
      hasError: hasError,
      formik: formik
    }), _jsx("input", {
      className: "form-duuf-input form-duuf-input-".concat(type),
      type: inputTypes[type] || type,
      id: fieldId,
      name: fieldId,
      placeholder: data.placeholder,
      onBlur: handleBlur,
      onChange: handleChange,
      value: values[fieldId],
      maxLength: data.maxLength === 0 ? undefined : data.maxLength
    })]
  });
};
export default TextField;